/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-09-06 10:54:46
 * @LastEditTime: 2022-09-29 10:21:25
 * @FilePath: /insurforce-backstage-platform-side/src/views/reportForm/exportManage/request.js
 */
import request from '@/utils/request2';

// 导出搜索参数
export function searchParams(data) {
  return request.post('admin/report-manager/searchParams', data);
}

// 获取导出字段
export function fieldList(data) {
  return request.post('admin/report-manager/fieldList', data);
}

// 导出接口
export function reportExport(data) {
  return request.post('/admin/report-manager/export', data);
}

// 获取归属信息
export function customerResource(data) {
  return request.post('admin/report-manager/customerResource', data);
}